var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "100%" },
          attrs: {
            filterable: true,
            remote: true,
            "remote-method": _vm.getData,
            "value-key": "Key",
            size: "small",
            clearable: _vm.clearable,
            disabled: _vm.readonly
          },
          on: { change: _vm.dataChange, clear: _vm.dataChange },
          model: {
            value: _vm.data,
            callback: function($$v) {
              _vm.data = $$v
            },
            expression: "data"
          }
        },
        _vm._l(_vm.datas, function(item) {
          return _c(
            "el-option",
            { key: item.Key, attrs: { label: item.Name, value: item } },
            [
              _c("div", { staticClass: "proItem" }, [
                _c("div", { staticClass: "name" }, [_vm._v(_vm._s(item.Name))]),
                _c("div", { staticClass: "companys" }, [
                  _c("div", { staticClass: "company" }, [
                    _vm._v("价值：" + _vm._s(item.Price))
                  ])
                ])
              ])
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }